import HomePage from './HomePage';
import Page from './page';

export default Page

export {HomePage}


// WEBPACK FOOTER //
// ./src/components/layouts/page/index.js